<template>
    <div>
        <div class="modal" tabindex="-1" id="msgBoxForm" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-danger">{{data.caption}}</h5>
                </div>
                <div class="modal-body">
                    <p v-html="data.message"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click.prevent="mrCancel()">Отмена</button>
                    <button type="button" class="btn btn-danger" @click.prevent="mrOk()">{{ okCaption }}</button>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>


<script>
import jQuery from 'jquery'
export default {
    data() {
        return {
            okCaption: 'Да',
        }
    },
    props: {data: Object},
    mounted() {
        if (this.data.show)
            this.showModalForm()      
        if (this.data.okCaption)
            this.okCaption = this.data.okCaption
    },
    watch: {
        'data.show': function() {
            if (this.data.show)
                this.showModalForm() 
            else
                this.hideModalForm()
        }
    },
    methods: {


        mrCancel() {
            this.$parent.ModalOkCancelData.show = false
            this.$parent.ModalOkCancelData.id = 0
        },
        mrOk() {
            this.$emit('mrok', this.data.id);
            //this.hideModalForm()
            this.$parent.ModalOkCancelData.show = false
            this.$parent.ModalOkCancelData.id = 0
        },

        showModalForm() {
            jQuery('#msgBoxForm').modal('show');
        },
        hideModalForm() {
            jQuery('#msgBoxForm').modal('hide');
        },

    }
}
</script>